import React from 'react';

import styles from './ResetPasswordView.module.scss';
import _ from 'lodash';
import { Row } from 'react-bootstrap';
import InputField from 'src/legacy/components/InputField';
import Button from 'src/components/button/index';
import { localizedStrings } from 'src/localization/index.jsx';
class ResetPasswordView extends React.Component {

  constructor(props) {
    super(props);

    this._handleChange = this._handleChange.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onResetClick = this.onResetClick.bind(this);

    this.state = {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      successMessage: 'none',
      errors: {}
    }

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedProfile = this.localizatedSettings.profile;
    this.localizedReset = this.localizedProfile.change_password;
  }

  componentWillReceiveProps(nextProps) {
    if(_.get(this.props, "errors.errors") != _.get(nextProps, "errors.errors")){
      var errors = this.state.errors;

      if(nextProps.errors) {
        const errorsFromProps = _.get(nextProps, "errors.errors", []);
        if(_.size(errorsFromProps) > 0) {
          nextProps.errors.errors.forEach(error => {
            errors[error.field] = error.message;
          })
        }
      }

      this.setState({
        errors: errors
      })
    }

    else if (this.props.changingPassword != nextProps.changingPassword) {

      if (!nextProps.changingPassword && nextProps.changedPassword) {
        this.setState({ successMessage: 'inline-block' });
        setTimeout(function () { this.setState({ successMessage: 'none' }); }.bind(this), 3000);
      }
    }
  }

  _handleChange(field, e) {
    const value = _.trim(e.target.value);
    this.setState({ [field]: value });
  }

  onChangePassword() {
    const { oldPassword, newPassword1, newPassword2 } = this.state;
    const errors = {};
  
    if (!_.size(oldPassword)) errors.oldPassword = 'Old password is required';
    if (!_.size(newPassword1)) errors.newPassword1 = 'New password is required';
    if (!_.size(newPassword2)) errors.newPassword2 = 'Please re-enter the new password';
  
    if (!_.isEmpty(errors)) {
      this.setState({ errors });
      return;
    }
  
    this.setState({ errors: {} }, () => {
      this.props.changePassword(oldPassword, newPassword1, newPassword2);
    });
  }

  onResetClick() {
    this.props.resetForm();
    this._resetState();
  }

  _resetState() {
    this.setState({
      oldPassword: '',
      newPassword1: '',
      newPassword2: ''
    })
  }

  render() {
    return (
      <div className={styles.changePassword}>
        <h1>{this.localizedReset.title}</h1>
        <p>{this.localizedReset.description}</p>

        <Row className={styles.row}>
          <InputField
            className={styles.inputField}
            title={`${this.localizedReset.old_password}:`}
            placeholder=""
            value={this.state.oldPassword}
            onChange={this._handleChange.bind(this, 'oldPassword')}
            errorMessage={this.state.errors.oldPassword}
            type="password"
          />
        </Row>

        <Row className={styles.row}>
          <InputField
            className={styles.inputField}
            title={`${this.localizedReset.new_password}:`}
            placeholder=""
            value={this.state.newPassword1}
            onChange={this._handleChange.bind(this, 'newPassword1')}
            errorMessage={this.state.errors.newPassword1}
            type="password"
          />
        </Row>

        <Row className={styles.row}>
          <InputField
            className={styles.inputField}
            title={`${this.localizedReset.re_enter_password}:`}
            placeholder=""
            value={this.state.newPassword2}
            onChange={this._handleChange.bind(this, 'newPassword2')}
            errorMessage={this.state.errors.newPassword2}
            type="password"
          />
        </Row>

        <div className={styles.buttonTray}>
          <Button
            variant='primary'
            text={this.props.changingPassword ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save}
            disabled={this.props.changingPassword}
            className={styles.confirm}
            onClick={this.onChangePassword}
            icon='paperflite-tick'
          >
          </Button>
          <Button
            varaint='secondary'
            disabled={this.props.changingPassword}
            text={this.localizedCommonActions.cancel}
            className={styles.cancel}
            onClick={this.onResetClick}>
          </Button>
        </div>
      </div>
    )
  }
}

export default ResetPasswordView;